"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderItemFixed = void 0;
const class_validator_1 = require("class-validator");
const StockedProduct_1 = require("./StockedProduct");
const SalesOrderItem_1 = require("./SalesOrderItem");
const TSalesOrderItemType_1 = require("../types/TSalesOrderItemType");
/**
 * The item and quantity that relates to the stocked product the customer
 * bought.
 */
class SalesOrderItemFixed extends SalesOrderItem_1.SalesOrderItem {
    constructor(product) {
        super();
        if (product) {
            this.product = product;
        }
    }
    get productId() {
        return this.product.productId;
    }
    get category() {
        return this.product.category;
    }
    get type() {
        return TSalesOrderItemType_1.TSalesOrderItemType.Fixed;
    }
    get title() {
        return this.product.title;
    }
    get price() {
        return this.product.retailPrice;
    }
    get description() {
        return this.product.description;
    }
    get fullDescription() {
        return this.description;
    }
    get image() {
        return this.product.imageUrl;
    }
    // TODO: move to zam specific
    get trtId() {
        const { product: { trtId } } = this;
        if (trtId === undefined) {
            return null;
        }
        return trtId;
    }
    serialize() {
        return Object.assign(Object.assign({}, super.serialize()), { product: this.product.serialize() });
    }
    static unserialize(data) {
        const newSalesOrderItemFixed = new this();
        newSalesOrderItemFixed.salesOrderId = data.salesOrderId;
        newSalesOrderItemFixed.product = StockedProduct_1.StockedProduct.unserialize(data.product);
        newSalesOrderItemFixed.quantity = data.quantity;
        newSalesOrderItemFixed.totalPrice = data.totalPrice;
        newSalesOrderItemFixed.priceDiscounted = data.priceDiscounted || 0;
        return newSalesOrderItemFixed;
    }
}
__decorate([
    (0, class_validator_1.IsNotEmpty)()
], SalesOrderItemFixed.prototype, "product", void 0);
exports.SalesOrderItemFixed = SalesOrderItemFixed;
//# sourceMappingURL=SalesOrderItemFixed.js.map